import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import HeaderPage from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";

const BilateralLoanData = (props) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <HeaderPage header="Préstamo" isBold={true}/>
            </Grid>
            <Grid item xs={3}>
                <DataTable
                    className="noHeader"
                    value={props.detailLoan_1}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>
                    <Column field="name" style={{fontWeight: 'bold'}}/>
                    <Column field="value"/>
                </DataTable>
            </Grid>
            <Grid item xs={3}>
                <DataTable
                    className="noHeader"
                    value={props.detailLoan_2}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>
                    <Column field="name" style={{fontWeight: 'bold'}}/>
                    <Column field="value"/>
                </DataTable>
            </Grid>
            <Grid item xs={3}>
                <DataTable
                    className="noHeader"
                    value={props.detailLoan_3}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>
                    <Column field="name" style={{fontWeight: 'bold'}}/>
                    <Column field="value"/>
                </DataTable>
            </Grid>
            <Grid item xs={3}>
                <DataTable
                    className="noHeader"
                    value={props.detailLoan_4}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>
                    <Column field="name" style={{fontWeight: 'bold'}}/>
                    <Column field="value"/>
                </DataTable>
            </Grid>
        </Grid>
    )
};

export default BilateralLoanData;

BilateralLoanData.propTypes = {
    detailLoan_1: PropTypes.object.isRequired,
    detailLoan_2: PropTypes.object.isRequired,
    detailLoan_3: PropTypes.object.isRequired,
    detailLoan_4: PropTypes.object.isRequired
};